import { createContext, ReactNode, useContext, useState } from 'react';

type StepOptions = 'termo' | 'conclusao';

interface ControllerState {
	step: StepOptions;
	goToConclusao: () => void;
}

const useControllerContext = createContext<ControllerState>({} as ControllerState);

interface ControllerProviderProps {
	children: ReactNode;
}

const UseControllerProvider: React.FC<ControllerProviderProps> = ({ children }) => {
  
  const [step, setStep] = useState<StepOptions>('termo');

	const goToConclusao = () => {
		setStep('conclusao');
	}
  
	const contextValue = {
		step,
		goToConclusao,
	};

  return <useControllerContext.Provider value={contextValue}>{children}</useControllerContext.Provider>;
};

const useController = (): ControllerState => {
  const context = useContext(useControllerContext);
  if (!context) throw new Error('useController must be used within an UseControllerProvider');
  return context;
};

export { UseControllerProvider, useController };
